// @flow
export { default } from './CalloutBadge';
export type { Props } from './CalloutBadge';



// WEBPACK FOOTER //
// ../react-lib/src/components/callouts/CalloutBadge/index.js